(function($){
    $(document).ready(function(){
        // Znajdź element .woocommerce-product-gallery__wrapper
        var galleryWrapper = $('.woocommerce-product-gallery__wrapper');

// Utwórz element <figure>
        var figureElement = $('<figure class="woocommerce-product-gallery__wrapper"></figure>');

// Przenieś zawartość galerii do elementu <figure>
        galleryWrapper.children().appendTo(figureElement);

// Zamień istniejący element .woocommerce-product-gallery__wrapper na <figure>
        galleryWrapper.replaceWith(figureElement);

        if($('.product-template-default').length > 0 && $('#qodef-woo-page').length <= 0){
            $('#product-container-ms').wrapAll('<div id="qodef-woo-page" class="qodef-grid-item qodef--single qodef-popup--magnific-popup qodef-magnific-popup qodef-popup-gallery" />');
        }
    })
})(jQuery)